import { IIncompleteMemberFromMatch } from '../../../members/types';
import { IApiMatch } from './match.types';

export const matchSerializer = (
  apiMatch: IApiMatch
): IIncompleteMemberFromMatch => {
  const attributes = apiMatch.attributes;
  const relationships = apiMatch.relationships;
  const mainPicture =
    relationships.mainPicture && relationships.mainPicture.data;

  return {
    id: relationships.member.data.id,
    attributes: {
      favorite: relationships.favorite,
      score: attributes.score,
      personalityScore: attributes.personality_score,
      valueScore: attributes.value_score,
      visionScore: attributes.vision_score,
      mainPicture: mainPicture && mainPicture.id,
    },
  };
};
